import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Features from './Features';
import Integrations from './Integrations';
import McpSection from './McpSection';
import About from './About';
import Testimonials from './Testimonials';
import Pricing from './Pricing';
import CTASection from './CTASection';
import Footer from './Footer';

const Home = () => {
  return (
    <div style={{ background: '#06041A', color: '#ffffff' }}>
      <Header />
      <Hero />
      <Features />
      <Integrations />
      <McpSection />
      <About />
      <Testimonials />
      <Pricing />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Home;
